export const listClubs = /* GraphQL */ `
  query ListClubs(
    $filter: ModelClubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClubs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        organization_type
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const coachByEmail = /* GraphQL */ `
  query CoachByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coachByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        email
      }
    }
  }
`;

export const athleteByEmail = /* GraphQL */ `
  query AthleteByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    athleteByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        email
    }
  }
}
`;